import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmDialogService } from 'src/app/adminUsers/confirm-dialog/confirm-dialog.service';
import { MenuService } from 'src/app/core/menu/menu.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { DataService } from 'src/app/Service/data.service';
import { UserblockService } from '../sidebar/userblock/userblock.service';
const screenfull = require('screenfull');

@Component({
  selector: 'app-applicant-header',
  templateUrl: './applicant-header.component.html',
  styleUrls: ['./applicant-header.component.scss']
})
export class ApplicantHeaderComponent implements OnInit {

  constructor(public menu: MenuService, public userblockService: UserblockService, public settings: SettingsService, public injector: Injector, private route: Router, private DataServiceObj: DataService, private confirmDialogService: ConfirmDialogService, private ngxLoader: NgxUiLoaderService) {

    // show only a few items on demo
     // for horizontal layout
    this.DataServiceObj.title.subscribe(updatedTitle => {
      this.length = updatedTitle;
    });
  }
  navCollapsed = true; // for horizontal layout
  menuItems = []; // for horizontal layout
  router: Router;
  role: any;
  firstName: any;
  userProfileData: any;

  isNavSearchVisible: boolean;
  @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button
  response: any;
  Alerts: any[];
  display: string;
  length: any;

  userFirstName: any;

  ngOnInit() {
    this.isNavSearchVisible = false;
    // var clicks = JSON.parse(sessionStorage.getItem('userLogin'));

    if (sessionStorage.getItem('consumerLogin')) {
      const sessionData = JSON.parse(sessionStorage.getItem('consumerLogin'));
      this.role = sessionData.Data.role;
      this.firstName = sessionData.Data.firstName;

      // this.getNotigication();
    }

    const ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
      this.fsbutton.nativeElement.style.display = 'none';
    }

    this.router = this.injector.get(Router);

    // Autoclose navbar on mobile when route change
    this.router.events.subscribe((val) => {
      // scroll view to top
      window.scrollTo(0, 0);
      // close collapse menu
      this.navCollapsed = true;
    });

  }

  toggleUserBlock(event) {
    event.preventDefault();
    this.userblockService.toggleVisibility();
  }

  openNavSearch(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setNavSearchVisible(true);
  }

  setNavSearchVisible(stat: boolean) {
    this.isNavSearchVisible = stat;
  }

  getNavSearchVisible() {
    return this.isNavSearchVisible;
  }

  toggleOffsidebar() {
    this.settings.toggleLayoutSetting('offsidebarOpen');
  }

  toggleCollapsedSideabar() {
    this.settings.toggleLayoutSetting('isCollapsed');
  }

  isCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }

  toggleFullScreen(event) {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }

  navigateTo2StepAuth() {
    //  this.route.navigate(['/twoFaAuth']);
    this.router.navigate(['/subscriber_edit_profile']);

    // window.scrollTo(0, 0);
  }

  consumerLogout() {
    const obj = this;
    this.confirmDialogService.confirmThis('Are you sure to logout?', function() {
      sessionStorage.clear();
      obj.DataServiceObj.RemoveUserToken();
      obj.route.navigate(['/consumer']);
    }, function() {
    });
  }

  subscriberEditProfile() {
    this.router.navigate(['/subscriber_edit_profile']);
  }

  subscriberNotifictaion() {
    this.router.navigate(['/alert-notification']);
  }

}
